import { render } from "./WorkYoutube.vue?vue&type=template&id=7806e5ce"
import script from "./WorkYoutube.vue?vue&type=script&lang=js"
export * from "./WorkYoutube.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__